import _ from 'lodash';

import BaseFlow from './Base';

class CreationFlow extends BaseFlow {
  constructor(options) {
    super(options);
  }

  getRequestParamsFromOtherSteps(step, stepsData) {
    const params = Object.values(this.steps).reduce((acc, s) => ({
      ...acc, ...s.getRequestParams(stepsData),
    }), {});
    return step.excludeStepDataFromParams(params);
  }

  async updateAndHideStepsByUrlQueryIds(stepsData, urlQueryIds, props) {
    let newStepsData = { ...stepsData };
    const { businessId } = this.options;

    if (urlQueryIds.locationId) {
      const step = this.steps.location;
      const params = this.getRequestParamsFromOtherSteps(step, stepsData);
      const { payload: locations } = await step.fetchRecords({
        ...params,
        ...urlQueryIds,
        businessId,
      }, props);
      if (locations.length === 1) {
        const location = locations[0];
        newStepsData = {
          ...newStepsData,
          location: {
            ...newStepsData.location,
            ...location,
            isHidden: true,
          },
        };
      }
    }

    if (urlQueryIds.serviceId || urlQueryIds.serviceCategoryId) {
      const step = this.steps.service;
      const params = this.getRequestParamsFromOtherSteps(step, stepsData);
      const { payload: categories } = await step.fetchRecords({
        ...params,
        ...urlQueryIds,
        businessId,
      }, props);

      const category = categories[0];
      const isOnlyOneCategory = categories.length === 1;

      if (isOnlyOneCategory) {
        newStepsData = {
          ...newStepsData,
          service: {
            ...newStepsData.service,
            serviceCategoryId: category.id,
            isProvedQueryCategory: true,
          },
        };
      }
      if (isOnlyOneCategory && category.services.length === 1) {
        const service = category.services[0];
        newStepsData = {
          ...newStepsData,
          service: {
            ...newStepsData.service,
            ...service,
            isHidden: true,
          },
        };
      }
    }

    if (urlQueryIds.staffId) {
      const step = this.steps.staff;
      const params = this.getRequestParamsFromOtherSteps(step, stepsData);
      const { payload: staff } = await step.fetchRecords({
        ...params,
        ...urlQueryIds,
        businessId,
      }, props);
      if (staff.length === 1) {
        const oneStaff = staff[0];
        newStepsData = {
          ...newStepsData,
          staff: {
            ...newStepsData.staff,
            id: oneStaff.id,
            name: oneStaff.formattedFullName,
            isHidden: true,
          },
        };
      }
    }

    return newStepsData;
  };

  async updateSupposedFirstStepByExternalRecords(stepsData, props) {
    const { businessId } = this.options;
    const supposedFirstStep = this.getFirstStep(stepsData);
    if (!supposedFirstStep.fetchRecords) {
      return stepsData;
    }

    const params = this.getRequestParamsFromOtherSteps(
      supposedFirstStep,
      stepsData,
    );
    const { payload } = await supposedFirstStep.fetchRecords({
      ...params,
      businessId,
    }, props);
    if (_.isEmpty(payload)) {
      return stepsData;
    }

    const newSupposedStepData = supposedFirstStep.updateDataByRecords(
      stepsData,
      payload,
    );
    return this.updateStepsData(stepsData, newSupposedStepData);
  }

  async prepareNextStep(step, stepsData, props) {
    const nextStep = this.getNextVisibleStep(step, stepsData);
    if (!nextStep.fetchRecords) {
      return stepsData;
    }

    const { businessId } = this.options;
    const params = this.getRequestParamsFromOtherSteps(
      nextStep,
      stepsData,
    );
    const { payload } = await nextStep.fetchRecords({
      ...params,
      businessId,
    }, props);
    if (_.isEmpty(payload)) {
      return stepsData;
    }

    const newStepData = nextStep.updateDataByRecords(
      stepsData,
      payload,
    );
    return this.updateStepsData(stepsData, newStepData);
  }
};

export default CreationFlow;
